// extracted by mini-css-extract-plugin
export default {"card":"card_card__iPtAn","mobile":"card_mobile__hbScZ"};